import React from 'react'
import {
  useLazyGetNotificationTemplateQuery,
  useLazyGetNotificationTemplatesQuery,
} from '../../store/kopiliot-api/notification-template'
import { NotificationTemplate } from '../../shared/models/notification.model'
import KopiliotList from '../../components/kopiliot-list/KopiliotList'
import { useNavigate } from 'react-router-dom'
import {
  defaultNotificationTemplateActionsRow,
  getColumnsForTableNotificationTemplates,
} from '../../features/notifications/templates-columns'
import AddOrEditNotificationTemplate from '../../features/notifications/list/AddOrEditNotificationTemplate'
import { EntityType } from '../../shared/models/entity-type.models'

const NotificationInbox = () => {
  const navigate = useNavigate()
  const [getTemplates, resultGetTemplates] =
    useLazyGetNotificationTemplatesQuery()
  const [getTemplate, resultGetTemplate] = useLazyGetNotificationTemplateQuery()
  const [currentTemplate, setCurrentTemplate] = React.useState<
    Partial<NotificationTemplate> | undefined
  >(undefined)
  const [showModalCreate, setShowModalCreate] = React.useState(false)
  const fetchTemplates = () => {
    getTemplates({
      textSearch: '',
      offset: 0,
      limit: 10,
    })
  }
  React.useEffect(() => {
    fetchTemplates()
  }, [])
  const onDelete = () => {}
  const onEdit = (id: string) => {
    getTemplate({
      id: id,
      entityType: EntityType.NOTIFICATION_TEMPLATE,
    })
    setShowModalCreate(true)
  }
  React.useEffect(() => {
    setCurrentTemplate(resultGetTemplate.data)
  }, [resultGetTemplate.data])
  return (
    <>
      <KopiliotList
        title={'Modèles'}
        icon={'users-viewfinder'}
        isLoading={resultGetTemplates.isLoading} // TODO CHANGE
        actionsProps={{
          onRefresh: () => {
            fetchTemplates()
          },
          onAdd: () => {
            setShowModalCreate(true)
          },
        }}
        data={resultGetTemplates.data}
        paginationProps={{
          pageLimit: 100, // paginationState.limit,
          totalRecords: resultGetTemplates.data?.totalRows || 0,
          onPageChanged: (page: {
            currentPage: number
            totalPages: number
            pageLimit: number
          }) => {
            /*dispatchPaginationAction({
              type: PaginationActionType.PAGE_CHANGE,
              payload: { ...page },
            })*/
          },
          onChangePageSize: (size: number) => {
            /*dispatchPaginationAction({
              type: PaginationActionType.PAGE_SIZE,
              payload: { pageSize: size },
            })*/
          },
        }}
        tableProps={{
          tableProps: {
            size: 'sm',
            className: 'mb-0 overflow-hidden table-hover cursor-pointer',
          },
          rowClassName: 'default__table-row align-middle fs-10',
          hiddenColumns: ['id'],
          headerClassName: 'bg-200 text-900 text-nowrap align-middle',
          cellClassName: 'py-2 pe-4',
          columns: getColumnsForTableNotificationTemplates(
            defaultNotificationTemplateActionsRow(onDelete, onEdit)
          ),
          onClickRow: (row) => {
            navigate(`${row.original.id?.id}`)
          },
        }}
        cardProps={{
          idAccessor: (item: NotificationTemplate) => item.id!.id,
          titleAccessor: (item: NotificationTemplate) => item.name,
          descriptionAccessor: (item: NotificationTemplate) => item.name,
          linkAccessor: (item: NotificationTemplate) => `${item.id!.id}`,
          //actionsRow: defaultNotificationTargetActionsRow(onDelete, onEdit),
        }}
      />
      <AddOrEditNotificationTemplate
        show={showModalCreate}
        onHide={() => {
          setShowModalCreate(false)
          setCurrentTemplate(undefined)
        }}
        entity={currentTemplate && currentTemplate}
      />
    </>
  )
}

export default NotificationInbox
